import { render, staticRenderFns } from "./ktpCourse.vue?vue&type=template&id=be1945dc&scoped=true"
import script from "./ktpCourse.vue?vue&type=script&lang=ts"
export * from "./ktpCourse.vue?vue&type=script&lang=ts"
import style0 from "./ktpCourse.vue?vue&type=style&index=0&id=be1945dc&prod&scoped=true&lang=scss"
import style1 from "./ktpCourse.vue?vue&type=style&index=1&id=be1945dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1945dc",
  null
  
)

export default component.exports